import { createLucideIcon } from 'lucide-react';
export const CheckSquareIcon = createLucideIcon('', [
  [
    'path',
    {
      d: 'M18.9412 3H3V21H21V11.8217',
      key: 'r4il4s',
    },
  ],
  [
    'path',
    {
      d: 'M9 10.6154L12.4737 14L21 6',
      key: 'p57gsd',
    },
  ],
]);
